(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flexible-cta-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flexible-cta')) {
    class FlexibleCTA extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.equalizeHeadings();
        this.addListeners();
      }

      equalizeHeadings() {
        const headings = this.querySelectorAll('[data-heading]');
        if (!headings.length) return;

        headings.forEach((h) => (h.style.height = ''));

        const maxHeight = Array.from(headings).reduce((max, h) => Math.max(max, h.getBoundingClientRect().height), 0);

        headings.forEach((h) => (h.style.height = `${maxHeight}px`));
      }

      /*
       * When a slide is hovered, set it as active and update the corresponding stat to active as well.
       */
      addListeners() {
        window.addEventListener('resize', this.equalizeHeadings.bind(this));
      }
    }

    customElements.define('flexible-cta', FlexibleCTA);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid-toggle-script"] && !Shopify.designMode) return;
  try {
    class GridToggle extends HTMLElement {
    constructor() {
      super();

      this.BUTTON_ACTIVE_CLASS = 'results-grid-toggle__button--active';
      this.GRID_CLASS = 'results-grid--columns-1';

    }

    connectedCallback() {
      this.addEventListeners();
    }

    /**
     * Adds click event listeners to the grid toggle buttons.
     */
    addEventListeners() {
      this.buttons.forEach((button) => {
        button.addEventListener("click", event => this.onClick(event));
      });
    }

    /**
     * @param {MouseEvent} clickEvent
     */
    onClick({ currentTarget: button }) {
      const columns = button.dataset.columns;
      const section = this.closest("[data-results-section]");

      if (!section) return;

      section.classList.toggle(this.GRID_CLASS, columns === "1");

      this.updateButtonState(columns);
    }

    /**
     * @param {string} columns
     */
    updateButtonState(columns) {
      this.buttons.forEach(button =>
        button.classList.toggle(this.BUTTON_ACTIVE_CLASS, button.dataset.columns === columns)
      );
    }

    /**
    * @returns {NodeListOf<Element>}
    */
    get buttons() {
      return this.querySelectorAll("[data-results-toggle]");
    }
  }

  customElements.define('results-grid-toggle', GridToggle);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stats-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stats-component')) {
    class Stats extends HTMLElement {
      constructor() {
        super();

        this.ACTIVE_STAT_CLASS = "stats__stat--active";
        this.ACTIVE_SLIDE_CLASS = "stats__slide--active";
      }

      connectedCallback() {
        this.addListeners();
      }

      /*
       * When a slide is hovered, set it as active and update the corresponding stat to active as well.
       */
      addListeners() {
        this.slides.forEach(slide => {
          slide.addEventListener("mouseenter", () => this.onMouseEnterSlide(slide));
        });
      }

      /*
       * On mouse enter of a slide, set the hovered slide and corresponding stat to active by toggling the active class.
       */
      onMouseEnterSlide(activeSlide) {
        const activeIndex = Number(activeSlide.dataset.index) - 1;

        this.slides.forEach((slide, index) => slide.classList.toggle(this.ACTIVE_SLIDE_CLASS, index === activeIndex));
        this.stats.forEach((stat, index) => stat.classList.toggle(this.ACTIVE_STAT_CLASS, index === activeIndex));
      }

      /*
       * Get all stats within the component.
       */
      get stats() {
        return this.querySelectorAll("[data-stat]");
      }

      /*
       * Get all slides within the component.
       */
      get slides() {
        return this.querySelectorAll("[data-slider-item]");
      }
    }

    customElements.define('stats-component', Stats);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-header-script"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.STICKY_CLASS = "sticky-header--sticky";
      this.HEADER_STICKY_CLASS = "header--sticky";

      this.header = this.querySelector("[data-header]");
      this.isOverlay = this.header.classList.contains("header--overlay");
      this.isSticky = false;
      this.isFixed = false;
      this.prevScrollY = window.scrollY;
      this.firstSection = document.querySelector("[data-section]");
      this.firstSectionBottom = this.firstSection ? this.firstSection.offsetTop + this.firstSection.offsetHeight : 0;
      this.announcementBar = document.querySelector("[data-announcement-bar]");
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

      this.init();
    }

    init() {
      window.addEventListener("scroll", () => this.onScroll(), { passive: true });

      this.onScroll();
    }

    /*
     * Handles the scroll event and determines whether the user is scrolling up or down
     */
    onScroll() {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < this.prevScrollY;

      this.updateOverlayOffset(currentScrollY);

      scrollingUp
        ? this.handleScrollingUp(currentScrollY)
        : this.handleScrollingDown(currentScrollY);

      this.prevScrollY = currentScrollY;
    }

    /*
     * Updates the top offset of the sticky header for overlay pages
     * Keeps the header pinned below the announcement bar until it scrolls off screen
     * @param {number} currentScrollY - The current vertical scroll position of the window
     */
    updateOverlayOffset(currentScrollY) {
      if (!this.isOverlay || this.announcementBarHeight <= 0) return;

      this.style.top = `${Math.max(0, this.announcementBarHeight - currentScrollY)}px`;
    }

    /*
     * Handles the logic for when the user is scrolling up
     * @param {number} currentScrollY - The current vertical scroll position of the window
     */
    handleScrollingUp(currentScrollY) {
      const pastTriggerPoint = currentScrollY <= this.firstSectionBottom;

      if (!this.isOverlay || pastTriggerPoint) {
        this.toggleSticky(false);
      }

      if (currentScrollY <= 0) {
        this.toggleFixed(false);
      }
    }

    /*
     * Handles the logic for when the user is scrolling down
     * @param {number} currentScrollY - The current vertical scroll position of the window
     */
    handleScrollingDown(currentScrollY) {
      const isPastFirstSection = currentScrollY > this.firstSectionBottom;
      const isPastAnnouncementBar = currentScrollY > this.announcementBarHeight;

      if (currentScrollY <= 0) return;

      if (isPastAnnouncementBar) this.toggleFixed(true);

      if (this.isOverlay && isPastFirstSection || !this.isOverlay && isPastAnnouncementBar) {
        this.toggleSticky(true);
      }
    }

    /*
     * Toggles the sticky visual state of the header
     * @param {boolean} sticky - Whether the header should show sticky styles
     */
    toggleSticky(sticky) {
      if (this.isSticky === sticky) return;

      this.isSticky = sticky;
      this.header.classList[sticky ? "add" : "remove"](this.HEADER_STICKY_CLASS);
    }

    /*
     * Toggles the fixed positioning of the sticky-header wrapper
     * Only removed at the top of the page to prevent layout shift flicker
     * @param {boolean} fixed - Whether the wrapper should be fixed
     */
    toggleFixed(fixed) {
      if (this.isFixed === fixed) return;

      this.isFixed = fixed;
      this.classList[fixed ? "add" : "remove"](this.STICKY_CLASS);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tours-filters-script"] && !Shopify.designMode) return;
  try {
    class ToursFilters extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.filters.forEach(filter => {
        filter.addEventListener("click", () => this.applyFilters(filter));
      });
    }

    /**
     * Show or hide tours based on active filters
     */
    applyFilters(filter) {
      const activeFilter = filter.dataset.toursFilterLink;

      this.updateFilters(filter);
      this.toggleSectionsDisplay(activeFilter);
    }

    /**
     * Show or hide tour sections based on the active filter
     * @param {string} activeFilter - The currently active filter
     */
    toggleSectionsDisplay(activeFilter) {
      this.tourSections.forEach(section => {
        const id = section.dataset.tourSection;
        const display = (activeFilter === "all" || activeFilter === id) ? "" : "none";

        this.toggleSectionDisplay(section, display);
      });
    }

    /**
     * @param {Element} section - The tour section to show or hide
     * @param {string} display - The CSS display value to apply to the section
     */
    toggleSectionDisplay(section, display) {
      section.style.display = display;
    }

    /**
     * Update the active filter link
     */
    updateFilters(filter) {
      this.filters.forEach(filter => filter.classList.remove("filter-links__link--active"));

      filter.classList.add("filter-links__link--active");
    }

    /**
     * @returns {NodeListOf<Element>}
     */
    get filters() {
      return this.querySelectorAll("[data-tours-filter-link]");
    }

    /**
     * @returns {NodeListOf<Element>}
     */
    get tourSections() {
      return document.querySelectorAll("[data-tour-section]");
    }
  }

  customElements.define("tours-filters", ToursFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-controls-script"] && !Shopify.designMode) return;
  try {
    class VideoControls extends HTMLElement {
    constructor() {
      super();

      this.PLAYING_CLASS = 'media__button--paused';
      this.MUTED_CLASS = 'media__button--muted';
    }

    connectedCallback() {
      this.addListeners();
      this.handleResize();
      this.detectAudio();
    }

    /**
     * Add event listeners to the button and resize observer
     */
    addListeners() {
      this.playStateButton.addEventListener('click', () => this.toggleMediaState('play'));
      this.muteStateButton.addEventListener('click', () => this.toggleMediaState());
      this.resizeObserver = new ResizeObserver(() => this.handleResize());
      this.resizeObserver.observe(document.body);
    }

    /**
     * Hide the mute button if none of the videos have an audio track.
     * Runs once when video loads.
     */
    detectAudio() {
      this.videos.forEach((video) => {
        const check = () => {
          if (typeof video.mozHasAudio !== 'undefined') {
            if (!video.mozHasAudio) this.muteStateButton.hidden = true;
            return;
          }
          const onPlaying = () => setTimeout(() => {
            const hasAudio = video.audioTracks?.length > 0 || video.webkitAudioDecodedByteCount > 0;
            if (!hasAudio) this.muteStateButton.hidden = true;
          }, 500);
          video.paused ? video.addEventListener('playing', onPlaying, { once: true }) : onPlaying();
        };
        video.readyState >= 1 ? check() : video.addEventListener('loadedmetadata', check, { once: true });
      });
    }

    /**
     * Toggle video state based on current viewport (mobile or desktop)
     */
    toggleMediaState(type) {
      this.videos.forEach((video) => this.toggleVideoState(video, type));
    }

    /**
     * Play or pause the video
     * @param {HTMLVideoElement} video - The video element to toggle
     * @param {string} type - The type of state to toggle ("play" or "mute")
     */
    toggleVideoState(video, type) {
      type === 'play' ? this.toggleVideoPlay(video) : this.toggleVideoMute(video);
    }

    /**
     * Play or pause the video
     * @param {HTMLVideoElement} video - The video element to toggle
     */
    toggleVideoPlay(video) {
      this.toggleVideoPlayState(video);
      this.toggleVideoPlayButtonState(video);
    }

    /**
     * Play or pause the video
     * @param {HTMLVideoElement} video - The video element to toggle
     */
    toggleVideoMute(video) {
      this.toggleVideoMuteState(video);
      this.toggleVideoMuteButtonState(video);
    }

    /**
     * Mute or unmute the video
     * @param {HTMLVideoElement} video - The video element to toggle
     */
    toggleVideoMuteState(video) {
      video.muted = !video.muted;
    }

    /**
     * Play or pause the video
     * @param {HTMLVideoElement} video - The video element to toggle
     */
    toggleVideoPlayState(video) {
      video.paused ? video.play() : video.pause();
    }

    /**
     * Toggle the play button state based on the video state
     * @param {HTMLVideoElement} video - The video element to check
     */
    toggleVideoPlayButtonState(video) {
      this.playStateButton.classList.toggle(this.PLAYING_CLASS, video.paused);
    }

    /**
     * Toggle the play button state based on the video state
     * @param {HTMLVideoElement} video - The video element to check
     */
    toggleVideoMuteButtonState(video) {
      this.muteStateButton.classList.toggle(this.MUTED_CLASS, video.muted);
    }

    /**
     * Handle video playback based on viewport changes
     */
    handleResize() {
      this.videos.forEach((video) => {
        const isMobileVideo = video.hasAttribute('data-media-player-mobile');

        if (video.readyState === 0) return;
        if (typeof video.play !== 'function') return;

        if (this.isMobile && isMobileVideo) video.play() ? video.play() : null;
        else if (!this.isMobile && !isMobileVideo) video.play() ? video.play() : null;
      });
    }

    /**
     * Initialize the video controls
     */
    get media() {
      return this.closest('[data-media]');
    }

    /**
     * Get the play button element
     */
    get playStateButton() {
      return this.querySelector('[data-media-play-state-button]');
    }

    /**
     * Get the mute button element
     */
    get muteStateButton() {
      return this.querySelector('[data-media-mute-state-button]');
    }

    /**
     * Get all video elements within the media container
     */
    get videos() {
      return this.media.querySelectorAll('[data-media-player], [data-media-player-mobile]');
    }

    /**
     * Determine if the current viewport is mobile
     */
    get isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }
  }

  customElements.define('video-controls', VideoControls);
  } catch(e) { console.error(e); }
})();

})();
